import { Col, Form, Input, Row, Select, Switch } from "antd";
import { FormInstance } from "antd/lib/form";
import React from "react";

type FormType = {
  form: FormInstance<any>;
  values?: any;
  onFinish: (values: any) => void;
  data: any;
};

export const SeasonForm: React.FC<FormType> = (props) => {
  const { form, values, onFinish, data } = props;

  const {
    collectionBrands: { nodes: collectionBrands },
  } = data;

  return (
    <Form layout="vertical" form={form} initialValues={values} onFinish={onFinish}>
      <Row gutter={[24, 0]}>
        <Col span={12}>
          <Form.Item name="code" label="Code" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="brandId" label="Brand" rules={[{ required: true, message: "is required" }]}>
            <Select>
              {collectionBrands.map((brand: any) => (
                <Select.Option key={brand.id} value={brand.id}>
                  {brand.code}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="nameIt" label="Name IT" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="nameEn" label="Name EN" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="kindIt" label="Kind IT" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="kindEn" label="Kind EN" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="shippingWindow" label="Shipping Window" >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="shippingExpected" label="Shipping Expected" >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="magoCode" label="Mago Code" rules={[{ required: true, message: "is required" }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="position" label="Position" rules={[{ required: true, message: "is required" }]}>
            <Input type="number" min={0} />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            name="isEnabled"
            label="Enabled"
            valuePropName={"checked"}
            rules={[{ required: true, message: "is required" }]}
          >
            <Switch />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item
            name="isStock"
            label="Stock"
            valuePropName={"checked"}
            rules={[{ required: true, message: "is required" }]}
          >
            <Switch />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
